export default __webpack_public_path__ + "static/media/arrow-green.03a2dee0.svg";